import { PolicyLayout, useSettings, ConfigField } from "@/components/PolicyLayout";

export default function AboutUs() {
  const s = useSettings();
  return (
    <PolicyLayout title="About Us" kicker="Our Story">
      <p>{s.brand} is an online store dedicated to serving devotees across India with authentic Hindu puja samagri, ready-made puja kits, havan essentials, idols, agarbatti, rudraksha, and other spiritual products. We started {s.brand} to solve a very real problem — buying puja samagri from scattered local shops often means missing an item on the day of the puja, spending hours running around, and settling for questionable quality.</p>

      <h2>What we do</h2>
      <p>{s.brand} brings the entire puja shopping experience online:</p>
      <ul>
        <li><b>Puja Samagri:</b> Roli, kumkum, chandan, akshat, moli, kapoor, ghee, and every everyday puja essential.</li>
        <li><b>Puja Kits:</b> Curated ready-made kits for Ganesh Puja, Lakshmi Puja, Shiv Puja, Satyanarayan Puja, Griha Pravesh, Havan, Diwali, Navratri and more — so nothing is missed.</li>
        <li><b>Idols & Murtis:</b> Ganesh, Lakshmi, Krishna, Hanuman, Durga, Shiva and other deities in brass, marble and other finishes.</li>
        <li><b>Rudraksha & Malas:</b> Rudraksha, Tulsi, Sphatik, Chandan malas for jap and meditation.</li>
        <li><b>Havan Samagri:</b> Havan mix, samidha, guggal, loban, camphor, kunds and complete havan kits.</li>
      </ul>

      <h2>Our promise</h2>
      <ul>
        <li><b>Genuine products only.</b> Every item is hand-checked before dispatch. If a product doesn't look right, we refuse to ship it.</li>
        <li><b>Transparent pricing.</b> The price you see is inclusive of all taxes. There are no hidden charges at checkout.</li>
        <li><b>Fair shipping.</b> Free shipping above ₹399 across India. Otherwise a nominal flat rate — clearly shown at checkout.</li>
        <li><b>Human support.</b> Real people answer emails, WhatsApp and phone during business hours.</li>
      </ul>

      <h2>The Smart Puja Kit Finder</h2>
      <p>One of the things we're most proud of is our Puja Kit Finder — a simple guided experience that asks you what puja you're planning, the occasion, and how many people are participating, then recommends a complete kit with the right quantities. You can further customize the kit before adding to cart. It's the closest thing to having a helpful pandit walk you through your shopping list.</p>

      <h2>Business details</h2>
      <p><b>Brand:</b> {s.brand}<br/>
      <b>Registered address:</b> <ConfigField value={s.address} label="business address"/><br/>
      {s.legal_name ? <><b>Legal entity:</b> {s.legal_name}<br/></> : null}
      {s.gstin ? <><b>GSTIN:</b> {s.gstin}<br/></> : null}
      <b>Support email:</b> <ConfigField value={s.email} label="business email"/><br/>
      <b>Support phone:</b> <ConfigField value={s.phone} label="phone number"/></p>

      <h2>Talk to us</h2>
      <p>We love hearing from devotees. If you have suggestions, product requests, or need help with a puja, please reach out via our <a href="/contact">Contact page</a>. We read every message.</p>
    </PolicyLayout>
  );
}
